<template>
  <DashboardTemplate :navMenu="true">
    <div class="flex-display js-between ai-center  pd-b-5">
      <div class="text-left">
        <h3 class="mg-y-less text-font-24">
          ข้อมูลหลักสูตร {{ getPrefixLabel(prefix) }}{{ nameTh }} {{lastNameTh}}
        </h3>
        <p class="text-font-14">
          <span class="text-weight-bold">หลักสูตร </span
          ><span class="color-gray">{{ course.name }}</span>
        </p>
      </div>
            <el-button @click="csvExport" type="primary" round
        >ดาวน์โหลดข้อมูล</el-button
      >

    </div>
    <div v-loading="loading">
      <ActivitySubjectDetailList
        :showAction="false"
        edit="false"
        :courseScoreList="courseScoreList"
        :courseId="courseId"
        :userId="userId"
        :subjectSuccess="course.subject.length == course.subjectNumber"
      />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySubjectDetailList from "@/components/activity/ActivitySubjectDetailList";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  components: {
    DashboardTemplate,
    ActivitySubjectDetailList,
  },
  data() {
    return {
      activeName: "1",
      courseId: "",
      userId: "",
      loading: true,
      prefix: "",
      nameTh: "",
      lastNameTh:'',
      courseScoreList: null,
      course: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchStudentsById();
    this.fetchPercentSubjects();
  },
  methods: {
      csvExport() {
        let columnsTemplate =[
          'รายวิชา',
          'แบบทดสอบก่อนเรียน',
          'กระดานถาม-ตอบระหว่างเรียน',
          'งานที่ได้รับมอบหมาย',
          'แบบทดสอบหลังเรียน',
          'วีดีโอ'
        ]

        let title = []
        for (let index = 0; index < columnsTemplate.length; index++) {
          title.push(columnsTemplate[index])   
        }

        let data = []
        for (let index = 0; index < this.courseScoreList.subjects.length; index++) {
          let item = this.courseScoreList.subjects[index]
          let notOpen = Date.now() < new Date(item.open).getTime()

          let preTest = notOpen?'วิชายังไม่เปิด'
          :item.preTestDone?`${ item.preTestScore} เต็ม ${ item.preTestTotal}`
          :'ยังไม่ได้ทำข้อสอบ'

          let discussion = notOpen?'วิชายังไม่เปิด'
          :!item.haveDiscussion?"-"
          :item.discussion?`ตอบคำถามแล้ว`
          :'ยังไม่ได้ตอบคำถาม'

          let assignment = notOpen?'วิชายังไม่เปิด'
          :!item.haveAssignment?"-"
          :!item.takeAssignment?`ยังไม่ได้ส่ง`
          :item.assignment == 0?'ยังไม่ได้ตรวจ'
          :'ตรวจแล้ว'

          let postTest = notOpen?'วิชายังไม่เปิด'
          :!item.havePostTest?"-"
          :item.postTestDone?`${ item.postTestScore} เต็ม ${ item.postTestTotal}`
          :'ยังไม่ได้ทำข้อสอบ'

          let topic = notOpen?'วิชายังไม่เปิด'
          :!item.haveTopic?"-"
          :item.topic >= 100?`ดูวีดีโอแล้ว`
          :item.takeTopic?'กำลังเรียน'
          :'ยังไม่ได้เรียน'

          let obj ={
            subject:item.name,
            preTest:preTest,
            discussion:discussion,
            assignment:assignment,
            postTest:postTest,
            topic:topic,
          }
          data.push(obj)   
        }
        let csvContent = "";
        csvContent += [
            title.join(","),
            ...data.map(item => Object.values(item).join(","))
        ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

          
        var link = window.document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
        
        let dataFile = "ข้อมูลหลักสูตร"+this.getPrefixLabel(this.prefix)+''+this.nameTh+"_"+new Date().getDate()+'-'+(new Date().getMonth() + 1)+'-'+new Date().getFullYear()
        link.setAttribute("download", dataFile+'.csv');
        link.click();
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof  this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.userId = this.routeParams.userId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
      }
    },
    fetchPercentSubjects() {
      let obj = {
        courseId: this.courseId,
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`percent/subjects`, obj)
        .then((res) => {
          if (res.data.success) {
            this.courseScoreList = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchManagePoint error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
            this.lastNameTh = res.data.obj.surnameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
  },
};
</script>